import { createSlice } from "@reduxjs/toolkit";
const initialState = { history_state: [], ticketId: null, col: null };

const historyReducer = createSlice({
  name: "historyReducer",
  initialState,
  reducers: {
    historyState(state, action) {
      state.history_state = action.payload;
    },
    setTicketData(state, action) {
      state.ticketId = action.payload.ticketId;
      state.col = action.payload.col;
    },
    clearTicketData(state) {
      state.ticketId = null;
      state.col = null;
    },
  },
});
export const { historyState, setTicketData,clearTicketData } = historyReducer.actions;
export default historyReducer.reducer;
